import formsOrder from '@/store/modules/forms/order/formsOrder'
import { STORE_NAME_FORMS_ORDER } from '@/store/store.list'

export default {
  namespaced: true,
  modules: {
    [STORE_NAME_FORMS_ORDER]: formsOrder
  }
}
